module.exports = __webpack_public_path__ + "static/media/reflective-listening-large.b8c8f292.png";